module.exports = __webpack_public_path__ + "3e25e4d689fdd3d8210da962b1e4322c.jpg";